import {HeaderContainer, MarketplaceHeader} from '@treatwell/ui';
import {lazy, Suspense} from 'react';
import {useAppSelector} from '../hooks/store';
import {PageContainer} from '../pages';
import layoutStyles from '../pages/Layout.module.css';
import {
  selectChannelRequestStatus,
  selectIsWidget,
} from '../store/slices/channel/slice';
const WidgetHeader = lazy(
  () => import('../components/WidgetHeader/WidgetHeader'),
);

export const GenericHeader = () => {
  const channelStatus = useAppSelector(selectChannelRequestStatus);
  const isWidget = useAppSelector(selectIsWidget);
  return (
    <div className={layoutStyles.header}>
      <HeaderContainer data-cy="Header">
        <PageContainer withPadding>
          {channelStatus === 'fulfilled' && isWidget ? (
            <Suspense>
              <WidgetHeader />
            </Suspense>
          ) : (
            <MarketplaceHeader logoHref="/" />
          )}
        </PageContainer>
      </HeaderContainer>
    </div>
  );
};
